module.exports = __webpack_public_path__ + "img/slide_1.2db2c90f.jpg";